export enum StreamingState {
  loading,
  loaded,
  playing,
  waiting,
  paused,
  ended,
}
